// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Ou2c","forumContainer":"_2IZjw","divider":"_1JzBx"};